export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const RESET_PASSWORD = 'RESET_PASSWORD';
